import React, { useState } from 'react'
import Loader from './shared/Loader'
import { validateEmail, showFlashMessage } from '../helpers/utils'

export default function SetPasswordFieldForm({ formPath, tokenField, token, refParams, glfp, buttonTitle, termsUrl, privacyUrl, addendumUrl }) {
  const [password, setPassword]                         = useState('')
  const [passwordConfirmation, setPasswordConfirmation] = useState('')
  const [passwordValidator, setPasswordValidator]       = useState({})
  const [loading, setLoading]                           = useState(false)
  const [passwordShown, setPasswordShown]               = useState(false)
  const [confirmPasswordShown, setConfirmPasswordShown] = useState(false)

  const disableSave = !(passwordValidator.length && passwordValidator.number && passwordValidator.uppercase && passwordValidator.lowercase && password === passwordConfirmation)

  function handlePassword(event) {
    const value = event.target.value
    let validations = {}

    if (value.length >= 8) {
      validations = { ...validations, length: true }
    }
    if (value.match(/^.*\d.*$/)) {
      validations = { ...validations, number: true }
    }
    if (value.match(/^.*[A-Z].*$/)) {
      validations = { ...validations, uppercase: true }
    }
    if (value.match(/^.*[a-z].*$/)) {
      validations = { ...validations, lowercase: true }
    }

    setPasswordValidator(validations)
    setPassword(value)
  }

  function handleSubmit(event) {
    event.preventDefault()

    if (disableSave) {
      showFlashMessage(Cas.translations.password_validation_alert, 'error')

    } else {
      save()
    }
  }

  function save(event) {
    setLoading(true)

    let formData = new FormData()
    formData.append('account[password]', password)
    formData.append('account[password_confirmation]', passwordConfirmation)
    formData.append(`account[${tokenField}]`, token)

    for(const refParamKey in refParams) {
      formData.append(refParamKey, refParams[refParamKey])
    }

    if(glfp) {
      formData.append('glfp', glfp)
    }

    Rails.ajax({
      type: 'PUT',
      url: formPath,
      dataType: 'json',
      data: formData,
      success: res => {
        if (res.redirectUrl) {
          window.location.href = res.redirectUrl
        } else {
          setLoading(false)
        }
      },
      error: res => {
        showFlashMessage(res.error, 'error')
        setLoading(false)
      }
    })
  }

  return (
    <>
      <div className='field' style={{ position: 'relative' }}>
        <label>
          { Cas.translations.password }
        </label>
        <input
          type={ passwordShown ? "text" : "password" }
          autoFocus
          autoComplete='new-password'
          value={ password }
          onChange={ handlePassword }
        />
        { password.length > 0 &&
          <div className='show_password'>
            <i className={`pointer fa-light ${passwordShown ? 'fa-eye-slash' : 'fa-eye' }`} onClick={ ()=> setPasswordShown(prevState => !prevState) } />
          </div>
        }
      </div>

      <div className='field' style={{ position: 'relative' }}>
        <label>
          { Cas.translations.confirm_password }
        </label>
        <input
          type={ confirmPasswordShown ? "text" : "password" }
          autoFocus
          autoComplete='confirm-password'
          value={ passwordConfirmation }
          onChange={ (e)=> setPasswordConfirmation(e.target.value) }
        />
        { passwordConfirmation.length > 0 &&
          <div className='show_password'>
            <i className={`pointer fa-light ${confirmPasswordShown ? 'fa-eye-slash' : 'fa-eye' }`} onClick={ ()=> setConfirmPasswordShown(prevState => !prevState) } />
          </div>
        }
      </div>

      <div className='field flex-box flex-wrap items-center content-space-between'>
        <div className={`pass-validator ${passwordValidator.length ? '' : 'invalid'} `}>
          { Cas.translations.password_length }
        </div>
        <div className={`pass-validator ${passwordValidator.number ? '' : 'invalid'} `}>
          { Cas.translations.password_number }
        </div>
        <div className={`pass-validator ${passwordValidator.uppercase ? '' : 'invalid'} `}>
          { Cas.translations.password_uppercase }
        </div>
        <div className={`pass-validator ${passwordValidator.lowercase ? '' : 'invalid'} `}>
          { Cas.translations.password_lowercase }
        </div>
      </div>

      <div className='actions'>
        { !loading ?
          <div className='flex-box items-center content-center'>
            <button type='submit' className={`button ${disableSave ? 'disabled' : ''}`} onClick={ handleSubmit }>
              { buttonTitle  }
            </button>
          </div>
          :
          <div className='flex-box content-center'>
            <Loader size='small' position='centered'/>
          </div>
        }
      </div>
    </>
  )
}
